export default __webpack_public_path__ + "static/media/bht1.3cc38dc1.png";